import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import styled from "styled-components";
import { VehicleCarIcon } from "../../../../../components/vehicleCarIcon";
import { ElectricVehicleApi } from "../../electricVehiclesAPI";

export const SidePanelHeader = (props: {
  electricVehicle: ElectricVehicleApi;
}) => {
  return (
    <StyledPanelContainer>
      <StyledContent>{props.electricVehicle.registrationNumber}</StyledContent>
      <VehicleCarIcon
        registrationNumber={props.electricVehicle.registrationNumber}
      />
    </StyledPanelContainer>
  );
};

const StyledPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const StyledContent = styled.div`
  ${typographies["Header/H4"]};
`;
